import axios from 'axios';

// Onboarding идёт через gateway (`/onboarding/v1/*`). Запросы выполняются без access-токена:
// до создания организации у пользователя его нет, а 401 здесь означает невалидную
// onboarding-сессию, а не истёкший access-токен, поэтому auth-интерцепторы
// (refresh/logout/redirect) этому клиенту противопоказаны.
// Gateway ждёт обычные запросы до 30 с, генерацию договоров — до 120 с.
// Клиент должен дождаться его ответа, включая ошибку, вместо преждевременного обрыва.
export const ONBOARDING_REQUEST_TIMEOUT_MS = 35000;
export const ONBOARDING_COMPLETION_TIMEOUT_MS = 125000;

export function getOnboardingApiBaseUrl() {
  return process.env.VUE_APP_ONBOARDING_API_URL
    || `${process.env.VUE_APP_SERVER_URL}/onboarding/v1`;
}

const onboardingAxios = axios.create({
  baseURL: getOnboardingApiBaseUrl(),
  timeout: ONBOARDING_REQUEST_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json',
  },
});

export function isOnboardingRequestCanceled(error) {
  return axios.isCancel(error) || error?.code === 'ERR_CANCELED';
}

export default onboardingAxios;
